import { Component, Input, OnInit } from '@angular/core';
import { IBlog, IBlogListResponse, IDashboardMumPayload } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-blogs-and-articles',
  templateUrl: './blogs-and-articles.component.html',
  styleUrls: ['./blogs-and-articles.component.scss']
})
export class BlogsAndArticlesComponent implements OnInit {

  blogs: Array<IBlog>;
  @Input() dashboard: IDashboardMumPayload;

  constructor() { }

  ngOnInit(): void {
    this.blogs = this.dashboard.recentPosts.slice(0,5);
  }

}
